module.exports = __webpack_public_path__ + "img/commandpost_driving.6eb8d999.svg";